import { Dispatch } from 'redux';
import {
  MQCategoryAction,
  MQInProgressAction,
  MQ_CATEGORY,
  MQ_IN_PROGRESS,
  MQ_STARTED,
  MQ_MESSAGE_SHOW,
  MQ_ELIGIBLE,
  ELIGIBILITY_CANNOT_BE_DETERMINED,
  MQ_VALIDATION_SHOW,
  MQ_SUBMIT,
  MQSubmitAction,
  MQSubmit,
  MQ_SET_DECLARATION,
  RESET_PAX_MQ,
  MQ_RESET_CATEGORY,
  RESET_MQ,
  MQ_COMPLETED
} from './types';

export const mqSubmit =
  (data: MQSubmit) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: MQ_SUBMIT,
      payload: data
    } as MQSubmitAction);
  };

export const setMqInProgress = data => dispatch => {
  dispatch({
    type: MQ_IN_PROGRESS,
    payload: data
  } as MQInProgressAction);
};

export const setMqCategory = data => dispatch => {
  dispatch({
    type: MQ_CATEGORY,
    payload: data
  } as MQCategoryAction);
};

export const resetMqCategory = (paxId: number) => dispatch => {
  dispatch({
    type: MQ_RESET_CATEGORY,
    payload: { paxId }
  });
};

export const setMQStarted = (data: boolean) => dispatch => {
  dispatch({
    type: MQ_STARTED,
    payload: data
  });
};

export const setMQCompleted = (data: boolean) => dispatch => {
  dispatch({
    type: MQ_COMPLETED,
    payload: data
  });
};

export const setMQMessageShow = (data: boolean) => dispatch => {
  dispatch({
    type: MQ_MESSAGE_SHOW,
    payload: data
  });
};
export const setMQValidationShow = (data: boolean) => dispatch => {
  dispatch({
    type: MQ_VALIDATION_SHOW,
    payload: data
  });
};

export const setMQEligibility = (paxId: number, isEligible: boolean) => dispatch => {
  dispatch({
    type: MQ_ELIGIBLE,
    payload: { paxId, isEligible }
  });
};

export const setEligibilityCannotBeDetermineMsg = (data: boolean) => dispatch => {
  dispatch({
    type: ELIGIBILITY_CANNOT_BE_DETERMINED,
    payload: data
  });
};

export const setMQDeclaration = (paxId: number, declaration: boolean) => dispatch => {
  dispatch({
    type: MQ_SET_DECLARATION,
    payload: { paxId, declaration }
  });
};

export const resetPaxMQ = (paxId: number) => dispatch => {
  dispatch({
    type: RESET_PAX_MQ,
    payload: { paxId }
  });
};

export const resetMQ = () => dispatch => {
  dispatch({
    type: RESET_MQ
  });
};
